const version = require('./version');
const config = require('../../config');
const { blobURLFromSrc } = require('./blobs');

module.exports = function(src) {
	const worker = blobURLFromSrc(src).then(uri => {
		return new Worker(uri);
	});

	this.job = null;

	this.isAvailable = function() {
		return this.job == null;
	};

	this.run = async function(job) {
		if (this.job) return false;
		this.job = this.job || job;

		const requestId = (new Date().getTime()) + ':' + Math.random();
		worker.then(w => w.postMessage({
			action: job.method || 'run',
			args: job.args
		}));
	};

	worker.then(w => w.onmessage = message => {
		const data = message.data;
		if (data.event == 'progress') {
			if (this.job.progress) this.job.progress.fire(data.status);
		} else if (data.event == 'complete') {
			if (this.job.oncomplete) this.job.oncomplete.fire(data.result);
			this.job = null;
		}
	});
};
